import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from '../lib/LanguageContext';
import { translations } from '../lib/translations';
export function DeclarationSection() {
  const ref = useRef<HTMLElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const {
    lang
  } = useLanguage();
  const t = translations[lang].declaration;
  return <section ref={ref} style={{
    backgroundColor: 'var(--black)',
    minHeight: '70vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8rem 2rem'
  }} data-id="element-30">
      <div style={{
      textAlign: 'center',
      maxWidth: '48rem'
    }} data-id="element-31">
        {/* Thin rule */}
        <motion.hr initial={{
        opacity: 0,
        scaleX: 0
      }} animate={isInView ? {
        opacity: 0.3,
        scaleX: 1
      } : {
        opacity: 0,
        scaleX: 0
      }} transition={{
        duration: 0.8
      }} style={{
        border: 'none',
        borderTop: '1px solid var(--white)',
        width: '4rem',
        margin: '0 auto 4rem',
        transformOrigin: 'center'
      }} data-id="element-32" />

        {/* Line 1 */}
        <motion.p initial={{
        opacity: 0,
        y: 24
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 24
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} style={{
        fontFamily: '"IBM Plex Sans", sans-serif',
        fontWeight: 300,
        fontSize: 'clamp(1.5rem, 3.5vw, 2.25rem)',
        color: 'var(--grey-300)',
        lineHeight: 1.5,
        marginBottom: '1rem'
      }} data-id="element-33">
          {t.line1}
        </motion.p>

        {/* Line 2 */}
        <motion.p initial={{
        opacity: 0,
        y: 24
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 24
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} style={{
        fontFamily: '"IBM Plex Sans", sans-serif',
        fontWeight: 700,
        fontSize: 'clamp(1.5rem, 3.5vw, 2.25rem)',
        color: 'var(--white)',
        lineHeight: 1.5,
        marginBottom: '4rem'
      }} data-id="element-34">
          {t.line2}
        </motion.p>

        {/* Footer identity */}
        <motion.p initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {
        opacity: 0
      }} transition={{
        duration: 0.8,
        delay: 0.7
      }} style={{
        fontFamily: '"IBM Plex Mono", monospace',
        fontSize: '0.75rem',
        letterSpacing: '0.4em',
        textTransform: 'uppercase',
        color: 'var(--grey-500)'
      }} data-id="element-35">
          {t.footer}
        </motion.p>
      </div>
    </section>;
}